import React from "react";
import { Table } from "antd";

const wrapperStyle = {
  backgroundColor: "var(--surface, #fff)",
  border: "1px solid var(--blue-100, transparent)",
  padding: "16px",
  borderRadius: "8px",
};

const mobileWrapperStyle = {
  ...wrapperStyle,
  padding: "10px",
  overflowX: "auto",
};

const defaultPageSizeOptions = [10, 20, 50, 100];

function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);
  React.useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);
  return isMobile;
}

export default function DataTable({
  rowKey = "id",
  columns,
  data,
  loading,
  page,
  pageSize,
  onPageChange,
  pageSizeOptions = defaultPageSizeOptions,
  ...rest
}) {
  const isMobile = useIsMobile();

  return (
    <div style={isMobile ? mobileWrapperStyle : wrapperStyle}>
      <Table
        rowKey={rowKey}
        columns={columns}
        dataSource={data}
        loading={loading}
        size={isMobile ? "small" : "middle"}
        pagination={{
          current: page,
          pageSize,
          showSizeChanger: !isMobile,
          pageSizeOptions,
          onChange: onPageChange,
          size: isMobile ? "small" : "default",
        }}
        scroll={{ x: isMobile ? 500 : undefined }}
        {...rest}
      />
    </div>
  );
}
